import {Util} from "./Util.mjs";
import {KonvaComponentBase} from "./KonvaComponentBase.mjs";
import {TAGS} from "./GlobalStatics.mjs";
export class MiniLayoutPreview extends KonvaComponentBase
{
    /**
     * @private
     * @type {number}
     */
    placeholderCount;
    constructor(dotNetReference, domElementUid, promptText) {
        super(dotNetReference, domElementUid,promptText);
        this.resizeFunRef = this.resizeStage.bind(this);
        window.addEventListener("resize", this.resizeFunRef);
    }

    initLoad(layoutJson, { width, height }) {
        if (this.stage) {
            this.placeholderCount = 0;
            this.dispose();
        }
        let layout;
        try {
            layout = Konva.Node.create(layoutJson);
        } catch (e) {
            console.error("Invalid layout.", e);
            return false; // jeśli nie udało się zdeserializować jsona to zwracamy false i nie zakładamy nic
        }

        let borderWidth = Util.universalStandardUnits(1.2, width, height);
        const { scale: stageScale, ...stagePosition } = Util.getCentralFitInParams(
            width + 2 * borderWidth,
            height + 2 * borderWidth,
            document.getElementById(this.domElementUid).clientWidth,
            document.getElementById(this.domElementUid).clientHeight);

        this.pageScale = stageScale; // przypisanie skali strony na razie "wirtualnie"
        this.mainLayer = new Konva.Layer({ id: TAGS.MAIN_LAYER, imageSmoothingEnabled: false });

        //#region Fit-in layout
        const designWidth = layout.getAttr("designWidth");
        const designHeight = layout.getAttr("designHeight");
        const clientRect = layout.getClientRect(); //pobranie obszaru w którym coś jest
        //console.log("ClientRect: ", clientRect);
        const hasMargin = (clientRect.x > 0 || clientRect.y > 0) && (clientRect.width <= designWidth && clientRect.height <= designHeight);
        const fitingFunction = hasMargin ? Util.getCentralFitInParams : Util.getCentralFitOutParams; // jeśli jest margines robimy fit-in , jeśli nie to fit-out
        const { scale: layoutScale, ...position } = fitingFunction(
            designWidth,
            designHeight,
            width,
            height
        );
        layout.setAttrs({
            ...position,
            scaleX: layoutScale,
            scaleY: layoutScale
        });
        //#endregion

        layout.find(`.${TAGS.IMAGE_PLACEHOLDER}`).forEach(node => {
            //node.fill("#d8d8d8");
            Util.apply2StepLinearGradient(node, -layout.y() / layoutScale, (height - layout.y()) / layoutScale, "#ececec", "#d8d8d8");
            if (!node.hasStroke()) { //jeśli placeholder ma już obramowanie to nie będzie zlewał się z innymi placeholderami
                node.setAttrs({
                    strokeScaleEnabled: false,
                    stroke: "white",
                    strokeWidth: Util.universalStandardUnits(0.015, width, height) / layoutScale
                });
            }

        });
        layout.find(`.${TAGS.TEXTBOX}`).forEach(node => {
            if (!node.getAttr("definedText")) {
                node.setAttrs({
                    fill: "#6c6c6c",
                    opacity: 1,
                    width: node.width(), // poprawne działanie aligmentów i eclipse
                    height: node.height(),
                    fontSize: node.getAttr("defaultFontSize") || node.fontSize(),
                    wrap: "word",
                    fontFamily: "NunitoRegular",
                    letterSpacing: Util.universalStandardUnits(0.5, width, height) / layoutScale
                });
                Util.fitText(node, (node.getAttr("customPromptText") || this.defaultPromptText).toUpperCase(), node.fontSize(), 0.5 * node.fontSize());
                node.getParent().opacity(1);
                /*const borderRect = new Konva.Rect({
                    x: 0,
                    y: 0,
                    width: node.width(),
                    height: node.height(),
                    fill: "#f7f7f7"
                });

                ((parent) => {
                    parent.add(borderRect);
                    parent.opacity(1); // ustawienie opacity dla grupy nadrzędnej
                })(node.getParent());

                borderRect.moveToBottom();*/
            }
        });
        this.mainLayer.add(layout);

        //#region dodanie ramki
        const border = new Konva.Rect({
            x: 1 / this.pageScale - borderWidth / 2, // 1 pixel aby usunąć "prześwit"
            y: 1 / this.pageScale - borderWidth / 2,
            width: (width + borderWidth) - 2 / this.pageScale,  
            height: (height + borderWidth) - 2 / this.pageScale,
            stroke: "#d8d8d8",
            fill: "transparent",
            strokeWidth: borderWidth,
            cornerRadius: Util.universalStandardUnits(4, width, height),
            name: "border"
        });
        const borderCutter = border.clone({
            fill: "white", //bądź inny z otoczenia
            strokeWidth: 0,
            name: "borderCutter",
            globalCompositeOperation: "destination-atop"
        });
        //#endregion
        this.mainLayer.add(borderCutter); // dodanie maski do layera
        this.mainLayer.add(border); // dodanie ramki do layera

        this.stage = new Konva.Stage({
            container: this.domElementUid,
            width: (width + 2 * borderWidth)*stageScale, //-2 --> do idealnego przylegania
            height: (height + 2 * borderWidth)*stageScale, //-2
            offsetX: -borderWidth, //+1
            offsetY: -borderWidth, //+1
            listening: false,
            scaleX: stageScale,
            scaleY: stageScale
        });
        this.stage.add(this.mainLayer);
      
        //rozważyć cachowanie lub wręcz generowanie img i dodawanie w miejsce stage
        this.stage.batchDraw();
        return true; // jeśli udało się zdeserializować jsona to zwracamy true i wszytsko założyć
    }

    getPlaceholdersCount() {
        let placeholderCount = 0;
        this.mainLayer.find(`.${TAGS.IMAGE_PLACEHOLDER}`).forEach(node => placeholderCount++);
        return placeholderCount;
    }
}